import React, { useState, DragEvent, ChangeEvent } from "react";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes, FileUploadTypes, getError, getTitle, parseFile, testExtension } from "src/common";

type AllProps = {
  handleAction: ActionHandlerFunction;
  file_upload_type: FileUploadTypes;
}

function DraggableComponent(props: AllProps) {
  const { handleAction, file_upload_type } = props;
  const [drag_active, setDragActive] = useState(false);

  function handleFileParse(data: File) {
    parseFile(data, file_upload_type, handleAction);
  }

  function handleError(message: string) {
    handleAction({ actionType: AdminUIActionTypes.PageError, params: { message } });
  }

  function handleDragOver(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  }

  function handleDrop(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    e.stopPropagation();
    const data = e?.dataTransfer?.files[0];
    testExtension(data.name, file_upload_type) ? handleFileParse(data) : handleError(getError(file_upload_type));
  }
  
  function handleDragLeave(e: DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragActive(false);
  }

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    e.preventDefault();
    if (e?.target?.files && e?.target?.files[0]) {
      handleFileParse(e.target.files[0]);
    };
  }

  return <div className={`draggable-container ${drag_active ? "drag-active" : "drag-inactive"}`}
    onDragOver={handleDragOver}
    onDragLeave={handleDragLeave}
    onDrop={handleDrop}
  >
    <input onChange={handleChange} accept={file_upload_type} className="d-none" type="file" id="file-upload" aria-hidden="true" />
    <label id="label-file-upload" htmlFor="file-upload" className="d-flex flex-column justify-content-center align-items-center draggable-container-text">
      <p role="text" className="mb-0">{getTitle(file_upload_type)} <br/><i>or</i></p >
      <p role="text" className="mt-0">Click to choose file</p>
    </label>
  </div>;
}

export default React.memo(DraggableComponent);
